// extracted by mini-css-extract-plugin
export default {"container":"MiniTable_container__HpvxS","title":"MiniTable_title__erjgf"};